import { AdditionalCompensationCard } from 'modules/contracts/components/FlowPage/Steps/RoleLevelSalary/_AdditionalCompensations/AdditionalCompensationCard/AdditionalCompensationCard'
import type { InMemoryAdditionalCompensation } from 'modules/contracts/lib/contractFlowContext'

type AdditionalCompensationsListProps = {
  additionalCompensations: InMemoryAdditionalCompensation[]
  onEdit?: (additionalCompensation: InMemoryAdditionalCompensation) => void
  onDelete?: (additionalCompensation: InMemoryAdditionalCompensation) => void
  onRead?: (additionalCompensation: InMemoryAdditionalCompensation) => void
}

function AdditionalCompensationsList({
  additionalCompensations,
  ...crudCallbacks
}: AdditionalCompensationsListProps) {
  return additionalCompensations.map((additionalCompensation) => {
    return (
      <AdditionalCompensationCard
        key={
          additionalCompensation.tmpID !== undefined
            ? `tmp-${additionalCompensation.tmpID}`
            : `id-${additionalCompensation.id}`
        }
        {...additionalCompensation}
        {...crudCallbacks}
      />
    )
  })
}

export { AdditionalCompensationsList }
